export default "__VITE_ASSET__KscMEaTQ__"